<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vdNCVe/image/Cover.jpg?1733711378669" alt="This image is the cover for the book Lily's Adventure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lily's Adventure
      </h1>
      <p class="bookDescription body article font2">
        <p>Join Lily on a delightful adventure – a heartwarming tale of friendship and discovery! Meet Lily, a creative and kind girl who embarks on a joyful journey after helping a trapped cat named Whiskers. Together, they explore the town, meeting a colourful cast of feline friends along the way. Each cat teaches Lily valuable lessons about kindness, joy, the importance of helping others, and the wonders of learning. Be inspired by Lily to embrace your curiosity, be kind, and never stop seeking knowledge. Filled with charming rhymes and vibrant illustrations, Lily’s Adventure is a celebration of friendship, kindness, and finding the magic in everyday adventures. Join Lily and Whiskers as they journey through streets and alleys, spreading joy and laughter wherever they go. Get ready for a perfectly delightful story that will warm your heart and inspire you to cherish the moments shared with friends alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ivo ten Voorde
      </h2>
      
      <p class="authorDescription body article">Meet the author and illustrator Ivo ten Voorde, with stories so bold, Gather around because many tales are yet untold. With creativity as his sail, dreams his vast sea, He sets out to share his tales, as a gift to you with glee. Inspired by his daughter, whose imagination soars, Together they craft tales under the wide-open skies, outdoors. Joy and wonder in each story they weave, Magic in words, just believe and receive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a76d598